/**
 * Torn weapons from https://wiki.torn.com/wiki/Weapon
 * Full list excluding temporary (Claymore Mine, Pepper Spray, Tear Gas).
 * Must match netlify/functions/_shared/weapons.js
 */
export const WEAPONS = [
  '9mm Uzi', 'AK-47', 'AK74U', 'ArmaLite M-15A4', 'Axe', 'Ban Hammer', 'Baseball Bat',
  'Benelli M1 Tactical', 'Benelli M4 Super', 'Beretta 92FS', 'Beretta M9', 'Beretta Pico',
  'Blood Spattered Sickle', 'Blowgun', 'Blunderbuss', 'Bolt Gun', 'Bone Saw', 'Bo Staff',
  'Bread Knife', 'BT MP9', 'Bug Swatter', 'Bushmaster Carbon 15', 'Butterfly Knife',
  'Cattle Prod', 'Chainsaw', 'Chain Whip', 'China Lake', 'Claymore Sword', 'Cleaver',
  'Cobra Derringer', 'Combat Shotgun', 'Cricket Bat', 'Crossbow', 'Crowbar',
  'Crystalline Falcata', 'Dagger', 'Desert Eagle', 'Devil\'s Pitchfork', 'Diamond Bladed Knife',
  'Diamond Icicle', 'Dual 92G Berettas', 'Dual Axes', 'Dual Bushmasters', 'Dual Hammers',
  'Dual MP5s', 'Dual P90s', 'Dual Samurai Swords', 'Dual Scimitars', 'Dual TMPs',
  'Dual Uzis', 'Duke\'s Hammer', 'Egg Propelled Launcher', 'Enfield SA-80', 'Fine Chisel',
  'Fiveseven', 'Flail', 'Flamethrower', 'Flare Gun', 'Frying Pan', 'Glock 17',
  'Golden Broomstick', 'Gold Plated AK-47', 'Golf Club', 'Guandao', 'Hammer', 'Handbag',
  'Harpoon', 'Heckler & Koch SL8', 'Homemade Pocket Shotgun', 'Ice Pick', 'Ithaca 37',
  'Ivory Walking Cane', 'Jackhammer', 'Kama', 'Katana', 'Kitchen Knife', 'Knuckle Dusters',
  'Kodachi', 'Lead Pipe', 'Leather Bullwhip', 'Lorcin 380', 'Luger', 'M16 A2 Rifle',
  'M249 SAW', 'M4A1 Colt Carbine', 'MAC 10', 'Macana', 'Madball', 'Mag 7', 'Magnum',
  'Meat Hook', 'Metal Nunchaku', 'Milkor MGL', 'Millwall Brick', 'Minigun', 'MP 40',
  'MP5 Navy', 'MP5k', 'MP9', 'Naval Cutlass', 'Negev NG-5', 'Neutrilux 2000', 'Ninja Claws',
  'Nock Gun', 'P90', 'Pair of High Heels', 'Pair of Ice Skates', 'Penelope', 'Pen Knife',
  'Petrified Humerus', 'Pillow', 'Pink Mac-10', 'PKM', 'Plastic Sword', 'Poison Umbrella',
  'Prototype Qsz-92', 'Raven MP25', 'Rheinmetall MG 3', 'Riding Crop', 'RPG Launcher',
  'Ruger 57', 'Rusty Sword', 'Sai', 'Samurai Sword', 'Sawed-Off Shotgun', 'Scalpel',
  'Scimitar', 'SIG 550', 'SIG 552', 'Skorpion', 'SKS Carbine', 'Sledgehammer', 'Slingshot',
  'SMAW Launcher', 'Snow Cannon', 'Spear', 'Springfield 1911', 'Steyr AUG', 'Stoner 96',
  'Swiss Army Knife', 'S&W M29', 'S&W Revolver', 'Taser', 'Taurus', 'Tavor', 'TAR-21',
  'Thompson', 'TMP', 'Tranquilizer Gun', 'Twin Tiger Hooks', 'Type 98 Anti Tank', 'USP',
  'Vektor CR-21', 'Wand of Destruction', 'Wooden Nunchaku', 'Wushu Double Axes', 'XM8 Rifle',
  'Yasukuni Sword',
].sort((a, b) => a.localeCompare(b));
